import { render, staticRenderFns } from "./ChapterPage.vue?vue&type=template&id=167fa3b6&scoped=true&"
import script from "./ChapterPage.vue?vue&type=script&lang=js&"
export * from "./ChapterPage.vue?vue&type=script&lang=js&"
import style0 from "./ChapterPage.vue?vue&type=style&index=0&id=167fa3b6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167fa3b6",
  null
  
)

export default component.exports